import { createContext, useContext, useState, useEffect } from "react";

const MarketContext = createContext();

export const MarketProvider = ({ children }) => {
  const [market, setMarket] = useState(
    () => localStorage.getItem("market") || "india",
  );

  useEffect(() => {
    localStorage.setItem("market", market);
  }, [market]);

  const toggleMarket = (selectedMarket) => {
    setMarket(selectedMarket);
  };

  return (
    <MarketContext.Provider value={{ market, toggleMarket }}>
      {children}
    </MarketContext.Provider>
  );
};

export const useMarketToggle = () => useContext(MarketContext);
